import React from 'react'

function BulkActionsApply(props) {
  const { checkSelectedArrayLength, handleActions, applyFunction } = props
  return (
    <>
      {checkSelectedArrayLength > 0 ? (
        <div style={{ marginTop: '3px' }}>
          <label style={{ marginTop: '7px' }} htmlFor='languages'>
            Bulk Actions:
          </label>
          <select onClick={handleActions} required name='select' id='languages'>
            <option value='' disabled selected>
              Bulk Actions{' '}
            </option>
            <option value='Approve'>Approve</option>
            <option value='Draft'>Draft</option>
            <option name='chechboxdelete' value='Delete'>
              Delete
            </option>
          </select>
          <button onClick={applyFunction} className='m-1 btn btn-primary'>
            Apply{' '}
          </button>
        </div>
      ) : (
        <>
          <label style={{ marginTop: '7px' }} className='languages'>
            Bulk Actions:
          </label>
          <select disabled name='select' id='languages'>
            {' '}
            <option value='' disabled selected>
              Bulk Actions{' '}
            </option>
          </select>
          <button disabled onClick={applyFunction} className='m-1 btn btn-primary'>
            Apply{' '}
          </button>
        </>
      )}
    </>
  )
}

export default BulkActionsApply
